<template>
  <div>

    <Head />
    <div class="wrap"
         :class="{miniWrap: platform}">
      <div class="banner"></div>

      <div class="rights">
        <h1>经销商5大特权</h1>
        <ul>
          <li class="aa">
            <div class="img1"></div>
            <h3>海量资源</h3>
            <p>优质货源任意选择</p>
          </li>
          <li class="aa">
            <div class="img2"></div>
            <h3>收入丰厚</h3>
            <p>价格自定义</p>
          </li>
          <li class="aa">
            <div class="img3"></div>
            <h3>培训支持</h3>
            <p>行业大咖导师1对1培训</p>
            <p>帮助销售业绩翻倍</p>
          </li>
          <li class="aa">
            <div class="img4"></div>
            <h3>市场支持</h3>
            <p>一件代发，专业售后</p>
            <p>轻松解决后顾之忧</p>
          </li>
          <li class="aa">
            <div class="img5"></div>
            <h3>市场巨大</h3>
            <p>行业前景广阔</p>
            <p>开启全新创业路</p>
          </li>
        </ul>
      </div>

      <div class="ruless">
        <div class="headBar">经销商条款</div>
        <ul class="friend-items">
          <li>
            <div class="msg">
              <p class="name">1.具备公司资质</p>
              <p class="age">具有独立法人资格，合法经营</p>
            </div>
          </li>
          <li>
            <div class="msg">
              <p class="name">2.具有销售团队</p>
              <p class="age">专职销售团队，具有互联网或SaaS领域销售经营背景。</p>
            </div>
          </li>
          <li>
            <div class="msg">
              <p class="name">3.具有客户资源</p>
              <p class="age">拥有当地丰富的企业级资源或线下门店资源。</p>
            </div>
          </li>
          <li>
            <div class="msg">
              <p class="name">4.认可饷店文化</p>
              <p class="age">认同饷店的产品价值和文化理念，愿意跟饷店长期合作。</p>
            </div>
          </li>
        </ul>
      </div>
      <img class="service-entrance"
         src="../common/img/service-entrance.png"
         @click="onService" />
      <Service ref="service" />
      <div class="joins">
        <h2>成为经销商</h2>
        <i-form ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                label-position='top'
                style="text-align: left">
          <FormItem label="联系人姓名"
                    prop="name">
            <i-input v-model="formValidate.name"
                     size='large'
                     placeholder="请输入联系人的真实姓名"></i-input>
          </FormItem>
          <FormItem label="联系人手机号"
                    prop="phone">
            <i-input v-model="formValidate.phone"
                     size='large'
                     placeholder="请输入联系人的手机号码"></i-input>
          </FormItem>
          <FormItem label="联系人微信号"
                    prop="wx">
            <i-input v-model="formValidate.wx"
                     size='large'
                     placeholder="请输入联系人的微信号"></i-input>
          </FormItem>
          <div class="inline">
            <FormItem label="意向区域"
                      prop="prov">
              <Select v-model="formValidate.prov"
                      size='large'
                      placeholder="请选择省份">
                <Option v-for="(item, index) in options"
                        :key="index"
                        :value="item.label">{{item.label}}</Option>
              </Select>
            </FormItem>
            <FormItem label=""
                      prop="city">
              <Select v-model="formValidate.city"
                      size='large'
                      placeholder="请选择城市">
                <Option v-for="(item, index) in citys"
                        :key="index"
                        :value="item.label">{{item.label}}</Option>
              </Select>
            </FormItem>
          </div>
          <FormItem label="公司名称（以营业执照为准）"
                    prop="company">
            <i-input v-model="formValidate.company"
                     size='large'
                     placeholder="请输入营业执照上的公司名称"></i-input>
          </FormItem>
          <FormItem label="公司规模（总人数）"
                    prop="account">
            <i-input v-model="formValidate.account"
                     size='large'
                     placeholder="请输入公司的总人数"></i-input>
          </FormItem>
          <FormItem label="过往经营产品（曾经做过的产品）"
                    prop="before">
            <i-input v-model="formValidate.before"
                     size='large'
                     type="textarea"
                     :autosize="{minRows: 3,maxRows: 5}"
                     placeholder="请输入贵公司曾经做过的产品"></i-input>
          </FormItem>
          <FormItem label="现营业务（当前主营业务）"
                    prop="now">
            <i-input v-model="formValidate.now"
                     size='large'
                     type="textarea"
                     :autosize="{minRows: 3,maxRows: 5}"
                     placeholder="请输入贵公司当前的主营业务"></i-input>
          </FormItem>
          <FormItem>
            <Button type="error"
                    @click="handleSubmit('formValidate')"
                    size='large'
                    class="btn"
                    v-show="submitBtn">提交</Button>
            <Button type="error"
                    size='large'
                    class="btn disable"
                    v-show="!submitBtn">提交</Button>
          </FormItem>
        </i-form>
      </div>      

      <div class="submitLayer" v-show="submitSuccess">
        <div class="submitSuccess">
          <div class="close" @click="closeLayer"></div>
          <p>您已提交成功！我们的客服将在24小时内联系您，请您耐心等待。</p>
          <div class="iknow" @click="closeLayer">我知道了</div>
        </div>
      </div>

    </div>
    <Foot />
    <Login v-show="showLogin" />
    <LoginOut v-show="showLoginOut" />
  </div>
</template>

<script>
import Head from 'components/header'
import Foot from 'components/footer'
import Login from 'components/login'
import Service from 'components/service'
import LoginOut from 'components/loginout'
import { mapState, mapMutations } from 'vuex'
import { xdParter } from 'api/http'
import { provinceAndCityData } from 'element-china-area-data'
export default {
  data() {
    return {
      formValidate: {
        name: '',
        phone: '',
        wx: '',
        prov: '',
        city: '',
        company: '',
        account: '',
        before: '',
        now: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: this.validatePhone, trigger: 'blur' }
        ],
        wx: [
          { required: false, trigger: 'blur' }
        ],
        prov: [
          { required: true, message: '省份必选', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '城市必选', trigger: 'blur' }
        ],
        company: [
          { required: false, trigger: 'blur' }
        ],
        account: [
          { required: false, trigger: 'blur' }
        ],
        before: [
          { required: true, message: '过往产品介绍不能为空', trigger: 'blur' }
        ],
        now: [
          { required: true, message: '现营业务介绍不能为空', trigger: 'blur' }
        ],
      },
      options: provinceAndCityData,
      submitSuccess: false
    }
  },
  created() {
    this.setName(2)
    this.setPlatform()
    this.$track.sendLog('pageview', {
      spm: '3.1601'
    })
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    Head,
    Foot,
    Login,
    Service,
    LoginOut
  },
  computed: {
    ...mapState([
      'platform',
      'showLogin',
      'showLoginOut'
    ]),
    citys() {
      let that = this
      if (that.formValidate.prov) {
        let citys = []
        that.options.map(v => {
          if (v.label == that.formValidate.prov) {
            citys = v.children
          }
        })
        return citys
      } else {
        return []
      }
    },
    submitBtn() {
      let form = this.formValidate
      if (form.name && form.phone && form.prov && form.city && form.before && form.now) {
        return 1
      } else {
        return 0
      }
    }
  },
  methods: {
    ...mapMutations(['setName', 'setPlatform','setLoginWrap']),
    handleSubmit(name) {
      this.$track.sendLog('click', {
        spm: '3.1601.1797'
      })
      let that = this
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          let form = this.formValidate
          let res = await xdParter({
            parName: form.name,
            phone: form.phone,
            weChat: form.wx,
            province: form.prov,
            city: form.city,
            company: form.company,
            companySize: form.account || 0,
            onceGoodsDesc: form.before,
            currentGoodsDesc: form.now,
            parType: 1
          })

          if(res && res.success) {
            that.submitSuccess = true
            that.$refs['formValidate'].resetFields();
          } else {
            that.$Message.error(res.message)
          }
        } else {
          console.log('valid failed')
        }
      })
    },
    validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback('请输入正确的手机号码');
      } else {
        callback();
      }
    },
    onService() {
      let token = localStorage.getItem('akc_token')
      let akid = localStorage.getItem('akc_akid')
      let vipLevel = localStorage.getItem('akc_vip_level')
      if (!token || !akid || !vipLevel) {
        this.setLoginWrap(true)
        return
      }
      this.$refs.service.show(token, akid, vipLevel)
    },
    closeLayer() {
      this.submitSuccess = false
    }
  }
}
</script>

<style scoped lang="less">
.wrap {
  width: 100%;
  background: #fff;
  .service-entrance {
    width: 90px;
    height: 100px;
    position: fixed;
    bottom: 60px;
    right: 0;
    z-index: 100;
  }
  .banner {
    width: 100%;
    padding-bottom: 36%;
    background-image: url("../common/img/city-banner.jpg");
    background-size: 100% 100%;
  }
  .rights {
    margin-top: 82px;
    h1 {
      font-size: 36px;
      font-family: PingFang-SC-Heavy, microsoft yahei, arial, hiragino sans gb;
      font-weight: 800;
      color: #333;
      line-height: 50px;
    }
    ul {
      padding: 59px 100px 70px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        li.aa {
          display: flex;
          flex-direction:column;
          justify-content:center;
          align-items:center;          
        }
        .img1, .img2, .img3, .img4, .img5 {
          width:72px;
          height:72px;
          background-size: 100% 100%!important;
        }
        h3 {
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color:#333;
          line-height:22px;
          margin: 10px 0 9px;
        }
        p {
          font-size:12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:#666;
          line-height:17px;
        }
        .img1 {
          background-image: url('../common/img/source.png');
        }
        .img2 {
          background-image: url('../common/img/rich.png');
        }
        .img3 {
          background-image: url('../common/img/study.png');
        }
        .img4 {
          background-image: url('../common/img/market.png');
        }
        .img5 {
          background-image: url('../common/img/cook.png');
        }
      }
    }
  }
  .ruless {
    .headBar {
      font-size: 36px;
      font-family: PingFang-SC-Heavy, microsoft yahei, arial, hiragino sans gb;
      font-weight: 800;
      color: #333;
      line-height: 50px;
    }
    .friend-items {
      height: 150px;
      margin-top: 54px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      li {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 220px;
        height: 100%;
        text-align: left;
        background: #f7f7f7;
        .msg {
          p.name {
            font-size: 18px;
            font-family: PingFang-SC-Heavy, microsoft yahei, arial,
              hiragino sans gb;
            font-weight: 800;
            color: #333;
            line-height: 25px;
            margin: 28px auto 13px;
            text-align: center;
          }
          p.age {
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #666;
            line-height: 22px;
            padding: 0 20px;
          }
        }
      }
    }
  }
  .joins {
    width: 100%;
    padding-bottom: 60px;
    .inline {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      & > div {
        width: 49%;
      }
    }
    h2 {
      font-size: 36px;
      font-family: PingFang-SC-Heavy, microsoft yahei, arial, hiragino sans gb;
      font-weight: 800;
      color: #333;
      line-height: 50px;
      padding: 76px 0 42px;
    }
    .btn {
      width: 140px;
      height: 44px;
      background: #ec2232;
      border-radius: 2px;
      position: relative;
      left: 430px;
      top: 36px;
      &:hover {
        background: #fc3142;
      }
      &.disable {
        opacity: 0.3;
        color: #fff;
      }
    }
    em {
      padding: 0 0 10px 0;
      font-style: normal;
      display: inline-block;
      &::after {
        content: "*";
        display: inline-block;
        margin-left: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 12px;
        color: #ed4014;
      }
    }
  }
    
  .submitLayer {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(51,51,51,.7);
    .submitSuccess {
      width:320px;
      height:212px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 2px;
      .close {
        height: 20px;
        width: 20px;
        background-image: url('../common/img/close.png');
        background-size: 100% 100%;
        position: absolute;
        top: 17px;
        right: 17px;
        cursor: pointer;
      }
      p {
        font-size:16px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
        padding: 47px 30px;
        text-align: center;
      }
      .iknow {
        width:140px;
        height:44px;
        background:rgba(236,34,50,1);
        border-radius:2px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:44px;
        margin-left: 90px;
        cursor: pointer;
      }
    }
  }
}
</style>